// @flow
import { getLogger } from "common/logger";
import createInstance from "./uploader";
import { EVENT_TYPES } from "./common/events";
import getStore from "./store";
import bindActions, { types as ats } from "./store/actions";
import registerBluImpProcessors from "./fileUpload/processors";

const logger = getLogger();

type UploaderOptions = {
    createExternalInterface: Function,
    qsParams: Object,
};

const registerToStoreChanges = (store, onChange) => { // entry point to all uploader store changes!
	let currentState = store.getState();

	return store.subscribe(() => {
		const newState = store.getState();

		if (newState !== currentState) {
			const prevState = currentState;
			currentState = newState;
			onChange(newState, prevState);
		}
	});
};

export const DUMMY_CLOUD = "!!dummy_uploader!!";

/**
 * used for auth flow when UI is loaded only for the purpose of authenticating a 3rd party service (like Dropbox)
 */
export const createDummyUploader = () => {
	const noOp = () => {};

	return {
		on: (event: string, cb: Function) => {
			if (event === EVENT_TYPES.UPLOADER_READY) { // emit ready immediately
				cb();
			}
		},
		renderUploadField: noOp,
		isShowingOnStart: () => false,
		setCurrentSource: noOp,
		getStore: () => ({}),
		getConfig: () => ({ cloudName: DUMMY_CLOUD }),
	};
};

export default (options: UploaderOptions) => {
	logger.log("[uploader]: creating uploader instance with options: ", options);

	const store = getStore();
	const boundActions: { [string]: Function } = bindActions(store.dispatch);

	boundActions[ats.SET_UPLOADER_QS_PARAMS]({ params: options.qsParams });

	const externalApi = options.createExternalInterface({
		qsParams: options.qsParams,
		actions: boundActions,
	});

	const getState = store.getState;

	const uploader = createInstance({
		actions: boundActions,
		getState,
		externalApi,
		store, // for debugging purposes
	});

	registerToStoreChanges(store, uploader.processStateChange.bind(uploader));

	registerBluImpProcessors({ getState });

	return uploader;
};
